import { RecursoSistema } from '../generated/backend-enums.js';
export { RecursoSistema };
export const RecursoSistemaLabelsMap = {
    [RecursoSistema.PLANILHA_ATENDIMENTO]: 'Planilha de Atendimento',
    [RecursoSistema.PLANILHA_COMPRAS]: 'Planilha de Compras',
    [RecursoSistema.PLANILHA_PRE_PRODUCAO]: 'Planilha de Pré-Produção',
    [RecursoSistema.NOVA_AP]: 'Nova AP',
    [RecursoSistema.AP]: 'AP',
    [RecursoSistema.JOB]: 'Job',
    [RecursoSistema.GERENCIAR_CLIENTES]: 'Gerenciar Clientes',
    [RecursoSistema.FATURAMENTO_ATENDIMENTO]: 'Faturamento (Atendimento)',
    [RecursoSistema.FATURAMENTO_FINANCEIRO]: 'Faturamento (Financeiro)',
    [RecursoSistema.CONTATO_FACILITIES]: 'Contato (Facilities)',
    [RecursoSistema.PEDIDO_BRINDE_FACILITIES]: 'Pedido de gift (Facilities)',
};
